import type { RemoteParticipantWrapperProps } from '../session/session-grid/RemoteParticipantCell';
import { RemoteParticipantWrapper as BaseRemoteParticipant } from '../session/session-grid/RemoteParticipantCellWrapper';
import { useHandleReceivedMessageCallback } from './messages/useHandleReceivedMessageCallback';
import { useTrackSessionParticipantViewedEvent } from './useTrackSessionParticipantViewedEvent';

export function RemoteParticipant(props: Omit<RemoteParticipantWrapperProps, 'onMessageReceived'>) {
  const handleReceivedMessage = useHandleReceivedMessageCallback();
  useTrackSessionParticipantViewedEvent(props.remoteParticipant.identity);
  return <BaseRemoteParticipant {...props} onMessageReceived={handleReceivedMessage} />;
}
